import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { LocalizedCalendarComponent } from './localized-calendar.component';
import { forwardRef } from '@angular/core';

export const LOCALIZED_CALENDAR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LocalizedCalendarComponent),
  multi: true
};

export const LOCALIZED_CALENDAR_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => LocalizedCalendarComponent),
  multi: true
};




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/localized-calendar/localized-calendar.providers.ts